import { useMemo } from "react";
import { Card, Table, TableBody, TableCell, TableHeader, TableHead, TableRow } from "randmarcomps";
import { Job as ApiJob } from "randmar-api-client";
import Job from "../../stores/jobs/Job";
import { UtcSecondsToLocalDateString } from "../util/DateTimeUtil";

interface IProps {
  jobs?: (Job | ApiJob)[];
}

const isLegacyJob = (job: Job | ApiJob): job is Job => 'header' in job;

const convertLegacyJobToApiJob = (job: Job): ApiJob => ({
  Header: {
    ApplicationId: job.header?.applicationId,
    Comment: job.header?.comment,
    CreatedAt: job.header?.createdAt,
    Description: job.header?.description,
    FileNames: job.header?.fileNames,
    JobId: job.header?.jobId,
    Logs: job.header?.logs,
    Status: job.header?.status,
    Type: job.header?.type,
  }
});

const JobsGrid = ({ jobs: rawJobs }: IProps) => {

  const jobs = useMemo(
    () => rawJobs?.map(job => isLegacyJob(job) ? convertLegacyJobToApiJob(job) : job) ?? [],
    [rawJobs]
  );

  if (!jobs || jobs.length === 0) {
    return (
      <div className="grid place-items-center text-center">
        <p>There are no jobs!</p>
      </div>
    );
  }

  return (
    <Card>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Job</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Request time</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {
            jobs?.map((job) => (
              <TableRow key={job.Header?.JobId}>
                <TableCell>{job.Header?.Description}</TableCell>
                <TableCell>{job.Header?.Status}</TableCell>
                <TableCell>{UtcSecondsToLocalDateString(job.Header?.CreatedAt)}</TableCell>
              </TableRow>
            ))
          }
        </TableBody>
      </Table>
    </Card>
  );
};

export default JobsGrid;
